
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.987 10.573L16.28 6.28l1.414 1.414-4.293 4.293 4.293 4.293-1.414 1.414-4.293-4.293-4.293 4.293L6.28 16.28l4.293-4.293L6.28 7.694 7.694 6.28l4.293 4.293z","fill":"currentColor"}})])
          )
        }
      }
    